<style lang="less">
    @import "../../../styles/reset.less";
</style>
<template>
    <div class="copyrightDetails">
        <div class="container">
            <h3 class="page_title">作品登记证书（电子版）订单详情</h3>
            <!--       横幅状态        -->
            <div v-if="details.orderStatus=='reject' || details.orderStatus=='reject_editable' " class="audit_status error">
                <span class="audit_text">{{ '驳回原因：'+ details.rejectReason }}</span>
            </div>
            <ul class="details_group">
                <li class="details_item">
                    <h3 class="details_group_title">作品基本信息
                        <!--                        <span v-if="downloadFlag" @click="downloadHandle" class="title_right">下载作品文件</span>-->
                    </h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">作品名称：</span><span class="item_list_content">{{ details.workFullName }}</span>
                            <!--                            <span class="item_list_title">作品类型：</span><span class="item_list_content">{{(details.workTypeDesc == 'text' ? '文字类型' : details.workTypeDesc == 'media' ? '微视频类型' : details.workTypeDesc == 'picture' ? '图片类型' :'' )  }}</span>-->
                            <span class="item_list_title">作品类型：</span><span class="item_list_content">{{details.workTypeDesc}}</span>
                        </li>
                        <li class="details_content_item_list">
                            <!--                        <span class="item_list_title">权利取得：</span>   <span class="item_list_content">{{ details.powerBy == 1? '原始取得' : details.powerBy == 2 ? '承受' : details.powerBy == 3 ? '继承' : details.powerBy == 4 ? '其他' :''  }}</span>-->
                            <span class="item_list_title">作品创作性质：</span><span class="item_list_content">{{details.creativeType}}</span>
                            <!--                            <span class="item_list_title">权利归属：</span><span>{{ details.copyrightType == 1 ? '个人作品' : details.copyrightType == 2 ? '合作作品' : details.copyrightType == 3 ? '法人作品' : details.copyrightType == 4 ? '职务作品' : details.copyrightType == 5 ? '委托作品' : '' }}</span>-->
                            <span class="item_list_title">权利归属：</span><span>{{ details.copyrightType}}</span>
                        </li>
                      <li class="details_content_item_list">
                        <span class="item_list_title">作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者：</span><span
                          class="item_list_content">{{ details.authorName }}</span>
                      </li>
                      <li class="details_content_item_list">
                        <span class="item_list_title">著作权人：</span><span>{{ details.powerName }}</span>
                      </li>
                      <li class="details_content_item_list">
                        <span class="item_list_title">权利保证书：</span>
                        <div v-for="(item,index) in autGuarAnnexList" :key="index" class="item_list_img">
                          <a :href="item.attachmentUrl" target="_blank">预览</a>
                        </div>
                      </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品创作信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <!--                            <span class="item_list_title">创作开始时间：</span>-->
                            <!--                            <span class="item_list_content">{{ details.completeBegin ? details.completeBegin : ''  }}</span>-->
                            <span class="item_list_title">创作完成时间：</span><span class="item_list_content">{{ details.completeDate ? details.completeDate : '' }}</span>
                            <span class="item_list_title">创作地点：</span><span class="item_list_content">{{(details.completeCountry ? details.completeCountry : '') + (details.completeProvince ? '-' + details.completeProvince  : '' ) + (details.completeCity ? '-' + details.completeCity  : '' ) }}</span>
                        </li>
                        <!--                        <li class="details_content_item_list">-->
                        <!--                            <span class="item_list_title">创作地点：</span><span class="item_list_content">{{(details.completeCountry ? details.completeCountry : '') + (details.completeProvince ? '-' + details.completeProvince  : '' ) + (details.completeCity ? '-' + details.completeCity  : '' ) }}</span>-->
                        <!--                            <span class="item_list_title">修改次数：</span><span>{{ details.modifyNum ? details.modifyNum : '' }}</span>-->
                        <!--                        </li>-->
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品发表信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">发表状态：</span><span class="item_list_content">{{ details.publishStatus == 1 ? '已发表' : '未发表' }}</span>
                            <span class="item_list_title">首次发表时间：</span><span class="item_list_content">{{ details.publishStatus == 1 ?  details.publishDate && details.publishDate!='' ? details.publishDate : '' : '-'  }}</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">首次发表地点：</span><span class="item_list_content">{{(details.publishStatus == 1 ?  (details.publishCountry ? details.publishCountry : '' ) + (details.publishProvince ? '-' + details.publishProvince : '' )+ (details.publishCity ? '-' + details.publishCity : '') : '-')   }}</span>
                        </li>
                    </ol>
                  <ol class="details_content_item" v-if="details.publishStatus == 1">
                    <li class="details_content_item_list">
                      <span class="item_list_title" style="width: 160px;">已发表的截图或照片：</span><br>
                    </li>
                  </ol>
                  <ol class="details_content_item" v-if="details.publishStatus == 1">
                    <li class="details_content_item_list">
                      <span class="item_list_content">
                        <img :src="[details.publishUrl]" @click="preview(details.publishUrl)" alt="" style="cursor: pointer;">
                      </span>
                    </li>
                  </ol>
                </li>


                <li v-if="worksAttachments.length>0" class="details_item">
                    <h3 class="details_group_title">作品文件</h3>
                    <ol class="details_content_item" style="overflow-x: auto;">
                        <!--                        <li class="details_content_item_list">-->
                        <!--                            <p>未经合法授权，任何单位和个人不得进行复制、转载、改编或其它侵权行为。</p>-->
                        <!--                        </li>-->
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in worksAttachments" class="item_list_img">
                                <!--                                <img src="@/assets/file_icon2.png" alt="">-->
                                <img :src="[item.isIcon?item.url:default_icon]" alt="" @click="workDownLoad(item)" style="cursor: pointer;">
                                <a :href="item.url" target="_blank" :download="item.name" class="item_list_desc download_class">{{item.name}}</a>
                            </div>
                        </li>
                    </ol>
                </li>
              <li v-if="productImageList && productImageList.length>0" class="details_item">
                <h3 class="details_group_title">作品展示图</h3>
                <ol class="details_content_item">
                  <li class="details_content_item_list">
                    <div v-for="(item,index) in productImageList" :key="index" class="item_list_img">
                      <img :src="item.url" @click="preview(item.url)" alt="" style="cursor: pointer;">
                    </div>
                  </li>
                </ol>
              </li>

                <li v-if="otherAttachments.length>0" class="details_item">
                    <h3 class="details_group_title">附件</h3>
                    <ol class="details_content_item">
<!--                        <li class="details_content_item_list">
                            <p>未经合法授权，任何单位和个人不得进行复制、转载、改编或其它侵权行为。</p>
                        </li>-->
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in otherAttachments" class="item_list_img">
                                <!--                                <img src="@/assets/file_icon2.png" alt="">-->
                                <a :href="item.url" target="_blank" class="item_list_desc" style="color: #2d8cf0;">附件{{index+1}}</a>
                            </div>
                        </li>
                    </ol>
                </li>

                <li v-if="DecFile.length>0" class="details_item">
                    <h3 class="details_group_title">创作声明</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p>未经合法授权，任何单位和个人不得进行复制、转载、改编或其它侵权行为。</p>
                        </li>
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in DecFile" class="item_list_img">
                                <!--                                <img src="@/assets/file_icon2.png" alt="">-->
                                <img :src="item.url" alt="">
                                <a :href="item.url" target="_blank" class="item_list_desc">{{item.name}}</a>
                            </div>
                        </li>
                    </ol>
                </li>

                <li  v-if="powerScopes.length>0"  class="details_item">
                    <h3 class="details_group_title">权益拥有情况</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list layout">
                            <div v-for="(item,index) in powerScopes" class="item_list_img">
                                <p class="item_list_desc">{{item}}</p>
                            </div>
                        </li>
                    </ol>
                </li>
                <li v-if="details.creationIntentions" class="details_item">
                    <h3 class="details_group_title">创作意图</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">{{ details.creationIntentions ? details.creationIntentions :'' }}</p>
                        </li>
                    </ol>
                </li>

                <li v-if="details.creationOriginality" class="details_item">
                    <h3 class="details_group_title">作品独创性</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">{{ details.creationOriginality ? details.creationOriginality : '' }}</p>
                        </li>
                    </ol>
                </li>

                <li v-if="cerImgPrivateUrls.length>0" class="details_item">
                    <h3 class="details_group_title">作品登记证书</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in cerImgPrivateUrls" class="item_list_img">
                                <img :src="item.url" alt="">
                            </div>
                        </li>
                    </ol>
                    <!--                    <button @click="downLoadDci" class="downDciBtn">下载证书</button>-->
                    <a v-if="details.certUrl && details.certUrl!='' " :href="details.certUrl" download class="download_btn">下载证书</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import download from 'ly-downloader'
    import {_getDetail} from '@/api/register.js'
    import util from "../../../libs/util";

    const reImg = /^(bmp|BMP|png|PNG|jpg|JPG|gif|GIF|jpeg|JPEG)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;


    export default {
        metaInfo: {
            title: '登记详情|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            }, {
                name: 'Description',
                content: ''
            }]
        },
        name: "copyrightDetails",
        data() {
            return {
                copyrightDetailsId: '',
                details: [], //登记详情
                downloadFlag:false, //是否可下载
                downloadList:[], //下载列表
                DecFile:[], //创作声明文件
                productImageList: [], //作品展示图
                autGuarAnnexList: [], //权利保证书
                worksAttachments:[],//作品文件
                otherAttachments:[],//附件
                powerScopes:[],
                cerImgPrivateUrls:[],//证书，有2个，
                default_icon:require("./images/default_file.png"),
                /**
                 * 数据库返回的是文字，
                 * */
                powers:[{label:"个人作品",checked:true,value:"1"},{label:"法人作品",checked:false,value:"2"},
                    {label:"合作作品",checked:false,value:"3"},{label:"职务作品",checked:false,value:"4"},
                    {label:"委托作品",checked:false,value:"5"}],
                //权益拥有情况
                Ownership:[
                    { label: '发表权', value: '1',checked:false },
                    { label: '署名权', value: '2' ,checked:false},
                    { label: '修改权', value: '3' ,checked:false},
                    { label: '保保护作品完整权', value: '4' ,checked:false},
                    { label: '复制权', value: '5' ,checked:false},
                    { label: '发行权', value: '6' ,checked:false},
                    { label: '出租权', value: '7' ,checked:false},
                    { label: '展览权', value: '8' ,checked:false},
                    { label: '表演权', value: '9' ,checked:false},
                    { label: '放映权', value: '10' ,checked:false},
                    { label: '广播权', value: '11' ,checked:false},
                    { label: '信息网络传播权', value: '12' ,checked:false},
                    { label: '摄制权', value: '13' ,checked:false},
                    { label: '改编权', value: '14' ,checked:false},
                    { label: '翻译权', value: '15',checked:false },
                    { label: '汇编权', value: '16',checked:false },
                    { label: '其他', value: '17',checked:false },
                ],
            }
        },
        created() {
            if (this.$route.query.id && this.$route.query.id != '') {
                this.copyrightDetailsId = this.$route.query.id;
                this.getDetail();
            }
        },
        methods: {
            /************获取登记详情***********/
            getDetail() {
                let data = {orderSeqNo: this.copyrightDetailsId};
                _getDetail(data).then(res => {

                    if (res.code == 200) {
                        this.details = res.result;
                        let status = this.details.publishStatus ;
                        if(status == "未发表")
                        {
                            this.details.publishStatus = "0"
                        }else{
                            this.details.publishStatus = "1"
                        }
                        this.checkDownloadUrl();
                        this.DecFileFuc();
                        this.worksAttachmentFun();
                        this.otherAttachmentsFun();
                        this.powerScopeFun() ;
                        this.cerImgPrivateUrlFun();
                        this.handleProductImageList();
                        this.handleAutGuarAnnexList();
                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })
            },


            /**********校验下载链接********/
            checkDownloadUrl(){
                let downloadList = this.details.worksAttachments;
                if(downloadList && downloadList.length>0){
                    let reUrl01 = /^((ht|f)tps?):\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/;
                    let downloadFlag = false;

                    for(let i=0;i<downloadList.length; i++){
                        if(!reUrl01.test(downloadList[i])){
                            downloadFlag = false;
                            break
                        }
                        else{
                            downloadFlag = true;
                        }
                    }
                    this.downloadFlag = downloadFlag;
                }

            },

            downloadHandle(){
                let downloadList = this.details.worksAttachments;
                for(let i = 0; i<downloadList.length; i++){
                    download(1, downloadList[i], '作品'+i)
                }
            },

            workDownLoad(item){
                // debugger ;
                if(!item.isIcon){
                    download(1,item.url,"");
                }else{
                    let link = document.createElement("a");
                    link.href = item.url ;
                    link.download = item.name;
                    link.target="_blank";
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                }

            },

          preview(url){
            window.open(url, '_blank');
          },

          handleProductImageList(){
            let productImageAttachmentses = this.details.productImageAttachments;
            let productImageList = [];
            productImageAttachmentses.split(',').forEach((value, index) => {
              let obj = {};
              obj.attachmentUrl = value;

              obj.url = util.thumbnail(value, '148', '168');

              obj.name = '预览';
              obj.size = (value.attachmentSize) - 0;
              productImageList.push(obj);
            });
            this.productImageList = productImageList;
          },

          handleAutGuarAnnexList(){
            let autGuarAnnexAttachments = this.details.autGuarAnnexAttachments;
            console.log('autGuarAnnexAttachments==============' + autGuarAnnexAttachments)
            let autGuarAnnexList = [];
            autGuarAnnexAttachments.split(',').forEach((value, index) => {
              let obj = {};
              obj.name = '下载';
              obj.attachmentUrl = value;
              let layout = value.substring(value.lastIndexOf('.') + 1)
              if (reImg.test(layout)) {
                obj.name = '预览';
                obj.url = util.thumbnail(value, '148', '168');
              } else if (reMusic.test(layout)) {
                obj.url = this.music;
              } else if (reText.test(layout)) {
                obj.url = this.text;
              } else if (reVideo.test(layout)) {
                obj.url = this.video;
              } else {
                obj.url = this.other;
              }

              obj.size = (value.attachmentSize) - 0;
              autGuarAnnexList.push(obj);
            });
            this.autGuarAnnexList = autGuarAnnexList;
          },

            /************作品文件**************/
            worksAttachmentFun(){
                if(this.details.worksAttachments != null || this.details.worksAttachments.length > 0){
                    this.worksAttachments = [];

                    // let _url = "./images/default_file.png";
                    // let _url = require("./images/default_file.png");
                    let _isIcon = false ;
                    this.details.worksAttachments.forEach((item,index)=>{
                        let suffix = item.split(".").pop();
                        // bmp|png|jpg|gif|jpeg
                        if(suffix =="png" || suffix=="jpg" || suffix=="bmp" ||suffix=="jpeg" ||suffix =="gif"||
                            suffix =="PNG" || suffix=="JPG" || suffix=="BMP" ||suffix=="JPEG"||suffix=="GIF" ){
                            _isIcon = true ;
                        }
                        this.worksAttachments.push({
                            url:util.thumbnail(item),
                            isIcon:_isIcon,
                            name:"作品"+(index+1)+"."+suffix
                        })
                    })
                }
            },

            /************附件**************/
            otherAttachmentsFun(){
                if(this.details.otherAttachments != null && this.details.otherAttachments.length > 0 && this.details.otherAttachments[0] != ""){
                    this.otherAttachments = [];
                    // for(let i=0;i<fileList.length; i++){
                    //     DecFile.push({name:'职务作品声明文件' + this.fileType(fileList[i]),url:fileList[i]});
                    // }

                    this.details.otherAttachments.forEach((item,index)=>{
                        this.otherAttachments.push({
                            url:util.thumbnail(item),
                            name:"附件"+(index+1)+item.substr(item.length-4,item.length)
                        })
                    })
                }
            },

            /**********创作声明文件********/
            DecFileFuc(){
                let copyrightType ="" ;// this.details.copyrightType;
                this.powers.forEach(item=>{
                    if(item.label == this.details.copyrightType)
                        copyrightType = item.value ;
                })
                let DecFile = [];
                // debugger ;
                switch (copyrightType) {
                    /**
                     * 法人作品，职务作品，委托作品，3给才有创作声明， 且只有要给创作声明
                     * */
                    //法人作品
                    case  '3':{
                        let fileList = this.details.workInstruction.split(',');
                        for(let i=0;i<fileList.length; i++){
                            DecFile.push({name:'法人作品声明文件' + this.fileType(fileList[i]),url:fileList[i]});
                        }
                        break;
                    }

                    //职务作品
                    case '4':{
                        let fileList = this.details.workInstruction.split(',');
                        for(let i=0;i<fileList.length; i++){
                            DecFile.push({name:'职务作品声明文件' + this.fileType(fileList[i]),url:fileList[i]});
                        }
                        break
                    }

                    //委托作品
                    case  '5':{
                        let fileList = this.details.workInstruction.split(',');
                        for(let i=0;i<fileList.length; i++){
                            DecFile.push({name:'委托作品声明文件' + this.fileType(fileList[i]),url:fileList[i]});
                        }
                        break;
                    }

                    default:
                        break;

                }

                //其他材料信息声明文件 附件 otherAttachments
                // if(this.details.otherAttachments && this.details.otherAttachments!=''){
                //     // debugger ;
                //     // let fileList = this.details.otherAttachments.split(',')
                //     let fileList = this.details.otherAttachments;
                //     for(let i=0;i<fileList.length; i++){
                //         DecFile.push({name:'其他材料信息声明文件' + this.fileType(fileList[i]),url:fileList[i]});
                //     }
                // }

                this.DecFile = DecFile;
            },

            /*******权益拥有情况**********/
            powerScopeFun(){
                // debugger ;
                if(this.details.powerScope == null || this.details.powerScope =="")
                    return false ;
                this.powerScopes = [];
                this.details.powerScope.split(",").forEach(item=>{
                    let index = Number(item-1);
                    let obj = this.Ownership[index];
                    this.powerScopes.push(this.Ownership[index].label);
                })
                console.log(this.powerScopes);
            },
            /*******证书**********/
            cerImgPrivateUrlFun(){
                // debugger ;
                if(this.details.cerImgPrivateUrl != null && this.details.cerImgPrivateUrl.length > 0 && this.details.cerImgPrivateUrl[0] != ""){
                    this.cerImgPrivateUrls = [];
                    this.details.cerImgPrivateUrl.split(",").forEach((item,index)=>{
                        this.cerImgPrivateUrls.push({
                            url:item,
                        })
                    })
                }
            },

            /*******************下载证书*******************/
            downLoadDci(){
                let downloadList = this.details.certUrl;
                download(1,downloadList,'');
            },

            /**********文件类型判断********/
            fileType(filePath){
                //获取最后一个.的位置
                let index= filePath.lastIndexOf(".");
                //获取后缀
                let ext = filePath.substr(index+1);


                return (ext && ext!='' ? '.' + ext : '')
            }
        }
    }
</script>

<style scoped lang="less">

    .audit_status {
        width: 100%;
        text-align: center;
        height: 50px;
        padding: 15px 0;
        font-size: 14px;
        border: 1px solid #FF8800;
        box-sizing: border-box;
    }

    .audit_status.error {
        background: #ffcccc;
        color: #d81e06;
        border-color: #d81e06;

        .audit_text:before {
            content: '';
            padding-right: 30px;
            height: 20px;
            background: url(../user/more/authentication/images/audit_error.png) no-repeat left center;
            background-size: 20px 20px;
            display: inline-block;
            vertical-align: middle;
        }

    }


    .copyrightDetails {
        margin: 20px 0 50px;
        background: #FDFDFD;
    }

    .page_title {
        color: #323232;
        background: #fff;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.15);
        border-radius: 8px 8px 0 0;
        height: 50px;
        color: #323232;
        font-size: 14px;
        line-height: 50px;
        padding-left: 20px;
    }

    .details_group {
        width: 100%;
        overflow: hidden;
    }

    .layout{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .details_group .details_item:nth-child(odd) .details_content_item {
        background: #fcfcfc;
    }

    .details_group .details_item:last-child .details_content_item {
        background: #fff;
    }



    .details_group .details_group_title {
        color: #323232;
        height: 51px;
        line-height: 51px;
        background: #F8F8F8;
        font-size: 16px;
        padding-left: 20px;
        display: flex;
    }

    .details_group_title .title_right {
        margin-left: auto;
        padding-right: 30px;
        color: #FFA400;
        font-size: 14px;
        cursor: pointer;
    }

    .details_group .details_content_item {
        padding: 20px 40px;
        background: #fff;
    }

    .details_content_item .details_content_item_list {
        display: flex;
        padding-bottom: 20px;
        flex-wrap: wrap;
    }

    .details_content_item .details_content_item_list.img_group {
        white-space: nowrap;
        /*创作声明只有一个了，不用加scroll了*/
        /*overflow-x: scroll;*/
    }

    .details_content_item .details_content_item_list:last-child {
        padding-bottom: 0;
    }

    .details_content_item_list .item_list_title {
        width: 117px;
      font-size: 16px;
    }

    .details_content_item_list .item_list_content {
        width: 338px;
    }

    .details_content_item_list .item_list_paragraph {
        width: 690px;
        color: #666666;
        line-height: 20px;
        white-space: normal;
    }

    .details_content_item_list .item_list_img {
        margin-right: 30px;
        text-align: center;
    }

    .item_list_img img {
        display: block;
        /*width: 368px;*/
        /*height: 241px;*/
        width: 256px;
        height: 168px;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.24);
        border-radius: 6px;
        background: #f5f5f5;
        margin: 0 auto;
        object-fit: cover
    }

    .item_list_img .item_list_desc {
        padding-top: 15px;
        padding-bottom: 20px;
        display: block;
        color: inherit;
    }

    .download_class{
        color:rgba(71,73,160,1) !important;
        text-decoration: underline;
    }

    .details_content_item_list .item_list_content:last-child {
        flex: 1;
    }

    .details_content_item_list .cert_box {
        width: 485px;
        text-align: center;
    }

    .cert_box img {
        display: block;
        width: 485px;
        height: 340px;
        background: #f5f5f5;
    }

    .download_btn {
        width:182px;
        height:52px;;
        line-height: 52px;
        background: rgba(71,73,160,1);
        border-radius: 26px;
        color: rgba(255,255,255,1);
        font-size: 18px;
        font-weight:400;
        padding-left: 48px;
        /*margin: 20px auto 0;*/
        margin-left: 40px;
        margin-top: 20px;
        cursor: pointer;
        display: inline-block;
    }
    /*.downDciBtn{*/
    /*    width:182px;*/
    /*    height:52px;*/
    /*    background:rgba(71,73,160,1);*/
    /*    border-radius:26px;*/
    /*    font-size:18px;*/
    /*    font-weight:400;*/
    /*    color:rgba(255,255,255,1);*/
    /*    border:none ;*/
    /*    outline: none;*/
    /*    margin-left: 40px;*/
    /*    margin-top: 25px;*/
    /*    cursor: pointer;*/
    /*}*/
    /*.downDciBtn:hover{*/
    /*    background:rgba(71,73,160,0.9);*/
    /*}*/

</style>
